export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-model-d18aef8ac9db38d8d39d47b03c87f1c1.jpg";